import React from "react";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";

import { useTooltip } from "../../hooks/useTooltip";

export default function EstimateTdStart({ estimate }) {
  const ref = useTooltip();

  return (
    <td>
      <Link to={`/new/${estimate.id}`}>
        <i
          className="material-icons cursor-pointer green-text"
          data-tooltip="Start New Estimate"
          data-position="left"
          ref={ref}
        >
          note_add
        </i>
      </Link>
    </td>
  );
}

EstimateTdStart.propTypes = {
  estimate: PropTypes.shape({
    id: PropTypes.string,
  }),
};
